import { render, staticRenderFns } from "./anno-swiper.vue?vue&type=template&id=bcdbd9a2&scoped=true"
import script from "./anno-swiper.vue?vue&type=script&lang=js"
export * from "./anno-swiper.vue?vue&type=script&lang=js"
import style0 from "./anno-swiper.vue?vue&type=style&index=0&id=bcdbd9a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdbd9a2",
  null
  
)

export default component.exports